import SkillsContainer from './skills_container';

const Skills = SkillsContainer;
export default Skills;
